import { useQuery } from "@tanstack/react-query";
import fetch from "logic/rest/FetchProvider";
import { defaultOnError } from "util/conditional/onError";
import { qualifyUrl } from "util/URLUtils";
const url = qualifyUrl("/plugins/org.graylog.plugins.archive/index_sets/archive_settings");
export const INDEX_SET_ARCHIVE_SETTINGS_QUERY_KEY = "indexSetArchiveSettings";
const fetchIndexSetArchiveSettings = async () => fetch("GET", url);
const useIndexSetArchiveSettings = ({ enabled = true } = {}) => {
  const { data, isLoading } = useQuery({
    queryKey: [INDEX_SET_ARCHIVE_SETTINGS_QUERY_KEY],
    queryFn: () => defaultOnError(fetchIndexSetArchiveSettings(), "Loading the archive settings failed"),
    enabled,
    retry: 0
  });
  return { globalRetentionTime: data == null ? void 0 : data.global_retention_time, isLoading };
};
export default useIndexSetArchiveSettings;
